export default "__VITE_ASSET__B2SJuwb2__"